import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const SimpleTable = ({ headers, rows }) => {
  let key = 0;
  return (
    <div style={{display:'block', overflowX: 'scroll'}}>
    <Table size="small">
      <TableHead>
        <TableRow>
          {headers.map(header => (
            <TableCell key={key++}>{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(row => (
          <TableRow key={key++}>
            {row.map(cell => (
              <TableCell key={key++}>{cell}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </div>
  );
};

export default SimpleTable;
